// Last view used ("hr" | "me") per user, so HR users come back to the same
// view after login. Browser storage can be unavailable (private mode): ignore.
const keyFor = (userId) => `hris.view.${userId}`;

export const getLastView = (userId) => {
  if (!userId) return null;
  try {
    const v = localStorage.getItem(keyFor(userId));
    return v === "me" || v === "hr" ? v : null;
  } catch {
    return null;
  }
};

export const setLastView = (userId, view) => {
  if (!userId) return;
  try {
    localStorage.setItem(keyFor(userId), view);
  } catch {
    /* storage unavailable: the default view is used next time */
  }
};
